// @generated
// This file is automatically generated by Kanel. Do not modify manually.

/** Represents the enum public.notebook_source_code_language */
enum NotebookSourceCodeLanguage {
  python = 'python',
  r = 'r',
};

export default NotebookSourceCodeLanguage;
